import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Layout } from "./components/Layout";
import { Dashboard } from "./pages/Dashboard";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { URLList } from "./pages/URLList";
import { URLReviewQueue } from "./pages/URLReviewQueue";
import { ReviewNotices } from "./pages/ReviewNotices";
import { CaseList } from "./pages/CaseList";
import { AgencyList } from "./pages/AgencyList";
import { UserList } from "./pages/UserList";
import { EmailTemplateList } from "./pages/EmailTemplateList";
import { DomainList } from "./pages/DomainList";
import { HostingProviderList } from "./pages/HostingProviderList";
import { DomainRegistrarList } from "./pages/DomainRegistrarList";
import { RegistryList } from "./pages/RegistryList";
import { PaymentProcessorList } from "./pages/PaymentProcessorList";
import { AdTechList } from "./pages/AdTechList";
import { ISPList } from "./pages/ISPList";
import { BrowserList } from "./pages/BrowserList";
import { SearchEngineList } from "./pages/SearchEngineList";
import { CDNList } from "./pages/CDNList";
import { DNSList } from "./pages/DNSList";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/urls"
        element={
          <ProtectedRoute>
            <URLList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/url-review-queue"
        element={
          <ProtectedRoute>
            <URLReviewQueue />
          </ProtectedRoute>
        }
      />
      <Route
        path="/review-notices"
        element={
          <ProtectedRoute>
            <ReviewNotices />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases"
        element={
          <ProtectedRoute>
            <CaseList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/agencies"
        element={
          <ProtectedRoute>
            <AgencyList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <UserList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/templates"
        element={
          <ProtectedRoute>
            <EmailTemplateList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/domains"
        element={
          <ProtectedRoute>
            <DomainList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hosting-providers"
        element={
          <ProtectedRoute>
            <HostingProviderList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/domain-registrars"
        element={
          <ProtectedRoute>
            <DomainRegistrarList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registries"
        element={
          <ProtectedRoute>
            <RegistryList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-processors"
        element={
          <ProtectedRoute>
            <PaymentProcessorList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ad-tech"
        element={
          <ProtectedRoute>
            <AdTechList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/isps"
        element={
          <ProtectedRoute>
            <ISPList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/browsers"
        element={
          <ProtectedRoute>
            <BrowserList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/search-engines"
        element={
          <ProtectedRoute>
            <SearchEngineList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cdns"
        element={
          <ProtectedRoute>
            <CDNList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dns"
        element={
          <ProtectedRoute>
            <DNSList />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
